module.exports = __webpack_public_path__ + "static/media/final_dif_vardegrund.3aaab59f.png";